/**
 * @Author: Tom Voorneveld <tom>
 * @Date:   2018-02-07T21:09:10+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe
 * @Last modified by:   tom
 * @Last modified time: 2018-02-08T10:54:52+01:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved

Force a scroll Event to activate lazy loading for VueBootstrap images. See also _lazy-image.js

Example:
  invokeScrollEvent('Mounted', 200)
    note: to write to console
    wait: msec before kicking in the scroll, default 100
*/

export default function (note = '...', wait = 100) {
  /* global Event */
  let event

  setTimeout(function () {
    if (typeof (Event) === 'function') {
      // we have a non-IE browser
      console.log(`Force scroll Event ${wait}ms, ${note}`)
      event = new Event('scroll')
    } else {
      // grrrr Microshit does not understand Event , IE10/11
      console.log(`Force scroll Event (IE10/11) ${wait}ms, ${note}`)
      event = document.createEvent('Event')
      event.initEvent('scroll', true, true)
    }
    window.dispatchEvent(event)
  }, wait)
}
